module.exports = __webpack_public_path__ + "img/analyticsTeam.3d4d3199.svg";